import { render, staticRenderFns } from "./documento_exame.vue?vue&type=template&id=c17af6e0&scoped=true&"
import script from "./documento_exame.vue?vue&type=script&lang=js&"
export * from "./documento_exame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17af6e0",
  null
  
)

export default component.exports